module.exports = __webpack_public_path__ + "img/kzys-currency-guide-en.af8a0104.png";